import { render } from "./CourseCatalog.vue?vue&type=template&id=366a740b&scoped=true"
import script from "./CourseCatalog.vue?vue&type=script&lang=js"
export * from "./CourseCatalog.vue?vue&type=script&lang=js"

import "./CourseCatalog.vue?vue&type=style&index=0&id=366a740b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366a740b"]])

export default __exports__